
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hLeLq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a18cf004eafb0a9a00ba1c5b30fbbffb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cee2474668e13f28$var$_react = $cee2474668e13f28$var$_interopRequireDefault((parcelRequire("42omo")));

var $cee2474668e13f28$var$_baseNew = $cee2474668e13f28$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $cee2474668e13f28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/video-play-overlay
 * Usage guidance:
 * Single purpose - Reserved for play video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cee2474668e13f28$var$VideoPlayOverlayIcon = (props)=>/*#__PURE__*/ $cee2474668e13f28$var$_react.default.createElement($cee2474668e13f28$var$_baseNew.default, Object.assign({
        name: "VideoPlayOverlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888z" clip-rule="evenodd"/>`
    }, props));
$cee2474668e13f28$var$VideoPlayOverlayIcon.displayName = 'VideoPlayOverlayIcon';
var $cee2474668e13f28$var$_default = module.exports.default = $cee2474668e13f28$var$VideoPlayOverlayIcon;

});


//# sourceMappingURL=video-play-overlay.0278a0bb.js.map
